var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    staticStyle: { width: "100%" },
    attrs: {
      value: _vm.value,
      "fetch-suggestions": _vm.handleCountrys,
      placeholder: _vm.placeholder,
      "trigger-on-focus": false
    },
    on: { input: _vm.updateSelf }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }